import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MToasterHost } from '@/app/shared/ui/m-toaster';
import { ContentProtection } from '@/app/core/protection/content-protection';
import { ContentWatermark } from '@/app/core/protection/content-watermark';
import { TenantHostService } from '@/app/core/tenant-host/tenant-host.service';
import { SiteConsentBanner } from '@/app/domains/site/site-consent-banner';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, MToasterHost, ContentWatermark, SiteConsentBanner],
  host: {
    // Ensure root component fills the entire viewport
    class: 'flex min-h-full w-full flex-auto flex-col',
  },
  template: `
    <router-outlet />
    <m-toaster-host />
    <content-watermark />
    <!-- Tenant storefront: cookie consent for the tenant's own GA4 / Meta Pixel ids (lazy chunk). -->
    @if (isTenantHost) { @defer (on idle) { <site-consent-banner /> } }
  `,
})
export class App implements OnInit {
  private protection = inject(ContentProtection);
  protected readonly isTenantHost = inject(TenantHostService).isTenantHost;

  ngOnInit(): void {
    // Yüzey VERİLMİYOR: bu uygulama üç yüzeyi birden taşıyor (/admin, /portal,
    // vitrin) ve gezinirken aralarında geçiliyor — servis yoldan çıkarıyor.
    this.protection.init();
  }
}
